import type { Cor, Familia, Tema, Tom } from "../preferencias"
import { cn } from "../lib/cn"

type Base = { modo: Tema; cor: Cor; tom: Tom }

const TRACO = "h-1 rounded-full"

export function PreviaDoTema({ modo, cor, tom }: Base) {
  return (
    <div
      data-slot="previa-do-tema"
      data-cor={cor}
      data-tom={tom}
      data-tema={modo === "escuro" ? "escuro" : undefined}
      aria-hidden="true"
      className="flex aspect-[1.6] w-full flex-col overflow-hidden rounded-md border border-(--borda) bg-(--azul-50)"
    >
      <div className="flex h-[18%] items-center bg-(--azul-600) px-1.5">
        <span className={cn(TRACO, "w-6 bg-(--azul-200)")} />
      </div>
      <div className="flex min-h-0 flex-1">
        <div className="flex w-[22%] flex-col gap-1 bg-(--azul-800) p-1.5">
          <span className={cn(TRACO, "bg-(--azul-200)")} />
          <span className={cn(TRACO, "bg-(--azul-200)")} />
          <span className={cn(TRACO, "w-2/3 bg-(--azul-200)")} />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1.5 p-2">
          <span className={cn(TRACO, "h-1.5 w-1/2 bg-(--tinta)")} />
          <div className="flex flex-1 flex-col gap-1 rounded-sm border border-(--borda) bg-(--painel) p-1.5">
            <span className={cn(TRACO, "bg-(--borda-forte)")} />
            <span className={cn(TRACO, "w-3/4 bg-(--borda-forte)")} />
            <span className="mt-auto h-2 w-1/3 rounded-sm bg-(--azul-500)" />
          </div>
        </div>
      </div>
    </div>
  )
}

export function PreviaDaLeitura({ modo, cor, tom, grande }: Base & { grande: boolean }) {
  return (
    <div aria-hidden="true" className="flex w-full gap-2">
      {(["normal", "alto"] as const).map((contraste) => (
        <div
          key={contraste}
          data-slot="previa-da-leitura"
          data-cor={cor}
          data-tom={tom}
          data-tema={modo === "escuro" ? "escuro" : undefined}
          data-contraste={contraste === "alto" ? "alto" : undefined}
          className="flex min-w-0 flex-1 flex-col justify-center gap-1 rounded-md border border-(--borda) bg-(--painel) p-2.5"
        >
          <strong className={cn("truncate font-semibold text-(--tinta)", grande ? "text-[16px]" : "text-[14px]")}>Título</strong>
          <span className={cn("truncate text-(--tinta-fraca)", grande ? "text-[13.7px]" : "text-[12px]")}>Texto de exemplo</span>
          <i className="h-px bg-(--borda)" />
          <small className="truncate text-[10px] font-medium text-(--tinta-fraca)">{contraste === "alto" ? "Contraste alto" : "Contraste normal"}</small>
        </div>
      ))}
    </div>
  )
}

export function PreviaDaFonte({ modo, cor, tom, familia }: Base & { familia: Familia }) {
  return (
    <div
      data-slot="previa-da-fonte"
      data-familia={familia}
      data-cor={cor}
      data-tom={tom}
      data-tema={modo === "escuro" ? "escuro" : undefined}
      aria-hidden="true"
      className="flex w-full items-center gap-3 rounded-md border border-(--borda) bg-(--painel) p-2.5 [font-family:var(--fonte-carregada),var(--fonte)]"
    >
      <span className="text-[32px] leading-none font-semibold text-(--tinta)">Aa</span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <strong className="truncate text-[13px] font-semibold text-(--tinta)">Contrato de serviços</strong>
        <span className="truncate text-[12px] text-(--tinta-fraca)">ABCDEFGHIJ abcdefghij</span>
        <span className="truncate text-[12px] text-(--tinta-fraca)">0123456789 · R$ 1.234,56</span>
      </div>
    </div>
  )
}
